import { autoLogin } from '@/apiCalls/autoLogin';
import { setFirstName } from '@/context/borrower';
import { store } from '@/context/store';
import { setIsLoggedIn } from '@/context/user';
import {
    ELocalStorageVariables,
    getLocalStorageItem,
    removeLocalStorageItem,
    setLocalStorageItem,
} from '@/utils/localStorage';

import { getParameters } from '../getParameters';

export async function setInitialUserState(): Promise<void> {
    const authToken = getLocalStorageItem(ELocalStorageVariables.AUTH_TOKEN);
    const firstName = getLocalStorageItem(ELocalStorageVariables.FIRST_NAME);

    // Check if we have a token in URL parameters for auto-login
    const params = getParameters();
    const urlToken = params.get('token');

    console.log('setInitialUserState - authToken:', authToken);
    console.log('setInitialUserState - urlToken:', urlToken);
    console.log(
        'setInitialUserState - all params:',
        Object.fromEntries(params.entries())
    );

    if (urlToken && !authToken) {
        try {
            // Attempt auto-login with the token from URL
            const response = await autoLogin(urlToken);
            if (response?.success && response.token) {
                // Store the new token and user info
                setLocalStorageItem(
                    ELocalStorageVariables.AUTH_TOKEN,
                    response.token
                );
                if (response.borrower.firstName) {
                    setLocalStorageItem(
                        ELocalStorageVariables.FIRST_NAME,
                        response.borrower.firstName
                    );
                    store.dispatch(setFirstName(response.borrower.firstName));
                }
                store.dispatch(setIsLoggedIn(true));

                // Remove the token from URL to prevent re-use (only on success)
                const url = new URL(window.location.href);
                url.searchParams.delete('token');
                window.history.replaceState({}, '', url.toString());

                return;
            } else {
                console.error('Auto-login failed: Invalid response', response);
            }
        } catch (error) {
            console.error('Auto-login failed:', error);
            // Don't remove token on error - let user try again
        }
    }

    // Must have both existing token and firstName
    if (authToken && firstName) {
        store.dispatch(setIsLoggedIn(true));
        store.dispatch(setFirstName(firstName));
    } else {
        // If only one, remove it
        if (authToken)
            removeLocalStorageItem(ELocalStorageVariables.AUTH_TOKEN);
        if (firstName)
            removeLocalStorageItem(ELocalStorageVariables.FIRST_NAME);
    }
}
